import PropertyListing from "../Components/Property/PropertyListing";

const PropertyPage = () => {
  return (
    <PropertyListing />
  );
};

export default PropertyPage;
